<template>
  <div class="EmptyView" />
</template>

<script>
export default {};
</script>
